<template>
  <div>
    <Navbar v-if="navbar" />
    <div>
      <slot />
    </div>
    <Footer />
  </div>
</template>

<script>
import "../styles.scss";
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";

export default {
  data: () => {
    return {
      navbar: true,
      test: {
        display: "show"
      }
    };
  },
  mounted() {
    this.check_url();
  },
  methods: {
    check_url() {
      if (this.$route.params.device_type == "app") {
        this.navbar = false;
      } else {
        this.navbar = true;
      }
    }
  },
  components: {
    Navbar,
    Footer
  },
  watch: {
    $route() {
      if (this.$route.params.device_type == "app") {
        this.check_url();
      }
    }
  }
};
</script>
<style></style>
